"use strict";

exports.__esModule = true;

exports.default = function () {};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-register/lib/browser.js
// module id = 2145
// module chunks = 116